module.exports = __webpack_public_path__ + "img/4-3.8512c62a.jpg";